import { UnderConstruction } from '@luna/components/UnderConstruction';
import { HomeContent } from '@luna/screens/home/HomeContent';

export function SettingsView() {
  return (
    <HomeContent title="Settings">
      <UnderConstruction />
    </HomeContent>
  );
}
